import React from "react";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import vehicleMasterData from "../../../../store/VehicleMasterERP";

const OtherInformationAsset = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
 const BASEURL_GLOBAL =  process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  // const [isLoading, setIsLoading] = useState(true);
  const data = vehicleMasterData((state) => state.data);
 
  // VEHICLE RELATED
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [trailerType, setTrailerType] = useState("");
  const [assetCategory, setAssetCategory] = useState("");

  const [formData, setFormData] = useState({
    propeller1: "",
    propeller2: "",
      maxPax: "",
    data:[],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (data?.OM_VEHICLE_REG_NO) {
      getData(data?.OM_VEHICLE_REG_NO);
    }
  }, [data]);

  const getData = (vehicle) => {
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1362&OM_VEHICLE_REG_NO=${encodeURIComponent(vehicle)}`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((res) => {
        handleChange("data", res?.data);
        handleChange("propeller1", res?.data[0]?.OM_VEHICLE_PROPELLER_1_SERIAL)
        handleChange("propeller2", res?.data[0]?.OM_VEHICLE_PROPELLER_2_SERIAL)
        handleChange("maxPax", res?.data[0]?.OM_VEHICLE_PAX)
        // setIsLoading(false);
      })
      .catch((err) => {
        // setIsLoading(false);
        console.log("Error While fetching 1362", err);
      });
  };

  // if (isLoading) {
  //   return <LoadingSpinner />;
  // }

  return (
    <div className="text-xs">
      <div className=" mt-3 bg-gray-100 p-2 m-2 rounded-md">
        {/* 1st Row  */}
        <div className="flex gap-3">
          <div className="flex gap-2">
            <span className="lg:ml-2">Propeller 1 :</span>
            <Select
              className="w-40"
              value={
                formData?.propeller1
                  ? {
                      value: formData?.propeller1,
                      label: formData?.propeller1,
                    }
                  : { value: "", label: "Select Propeller 1" }
              }
              onChange={(e) => handleChange("propeller1", e.value)}
              options={[
                { value: "", label: "Select Vehicle Status" },
                ...formData?.data?.map((item) => ({
                  value: item?.OM_VEHICLE_PROPELLER_1_SERIAL,
                  label: item?.OM_VEHICLE_PROPELLER_1_SERIAL,
                })),
              ]}
            ></Select>
          </div>
          <div className="flex gap-2">
            <span className="lg:ml-2">Propeller 2 :</span>
            <Select
              className="w-40"
              value={
                formData?.propeller2
                  ? { value: formData?.propeller2, label: formData?.propeller2 }
                  : { value: "", label: "Select Propeller 2" }
              }
              onChange={(e) => handleChange("propeller2", e.value)}
              options={[
                { value: "", label: "Select Engine No" },
                ...formData?.data?.map((item) => ({
                  value: item?.OM_VEHICLE_PROPELLER_2_SERIAL,
                  label: item?.OM_VEHICLE_PROPELLER_2_SERIAL,
                })),
              ]}
            ></Select>
          </div>
          <div className="flex gap-2">
            <span className="lg:ml-2  text-right">Max Pax:</span>
            <input
              className="w-40 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
              type="text"
              value={formData?.maxPax}
              onChange={(e) => handleChange("maxPax", e.target.value)}
            ></input>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OtherInformationAsset;
